import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

export const useWorkspaceName = (workspace?: WorkspacesListingItem): string => {
  const intl = useIntl();

  return useMemo(() => {
    if (!workspace) {
      return intl.formatMessage({
        id: 'workspaces.workspace_list_title',
        defaultMessage: 'Workspace'
      });
    }

    return (
      workspace.name ||
      intl.formatMessage(
        { id: 'landing.default_workspace_name', defaultMessage: "{name}'s workspace" },
        { name: workspace.owner.first_name }
      )
    );
  }, [workspace, intl]);
};
